import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { ref, reactive, onMounted, toRefs, computed } from "vue";
import { getCurrentInstance } from "vue";
import apis from "@/api";
export default {
  components: {},
  name: "RequestLogComponent",
  props: ["initialData"],
  setup(props) {
    const {
      proxy
    } = getCurrentInstance();
    const data = reactive({
      queryParam: {
        startTime: "",
        endTime: "",
        mineDuration: "",
        maxDuration: "",
        status: "",
        method: ""
      },
      defaultDateTime: new Date(2000, 2, 1, 23, 59, 59),
      pageNo: 1,
      pageSize: 10,
      tableData: [],
      allData: [],
      columns: [{
        label: "ID",
        prop: "traceId"
      }, {
        label: "网关服务",
        prop: "gwIp"
      }, {
        label: "网关端口",
        prop: "gwPort"
      }, {
        label: "创建时间",
        prop: "startTime"
      }, {
        label: "结束时间",
        prop: "endTime"
      }, {
        label: "请求耗时",
        prop: "duration"
      }, {
        label: "请求uri",
        prop: "uri"
      }, {
        label: "请求方法",
        prop: "method"
      }, {
        label: "接入应用ID",
        prop: "appId"
      }, {
        label: "请求状态",
        prop: "status"
      }, {
        label: "请求用户",
        prop: "userId"
      }, {
        label: "服务名称",
        prop: "svcName"
      }, {
        label: "服务IP",
        prop: "svcIp"
      }, {
        label: "服务端口",
        prop: "svcPort"
      }],
      total: 11,
      currentPage: 1
    });
    onMounted(() => {
      queryRequestLogList();
    });
    //查询数据接方法
    const queryRequestLogList = () => {
      apis.listRequestLogs({
        pageNo: data.currentPage,
        pageSize: data.pageSize,
        ...data.queryParam
      }).then(res => {
        if (res.success) {
          data.tableData = res.data.records;
          data.total = res.data.total;
          data.currentPage = res.data.current;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    //删除数据
    const doDeleteHandler = row => {
      apis.doDeleteRequestLog({
        id: row.traceId
      }).then(res => {
        if (res.code == "200") {
          queryRequestLogList();
        } else {}
      });
    };
    const resetForm = form => {
      proxy.$refs[form].resetFields();
      currentChange(1);
    };

    //换页触发
    const currentChange = index => {
      data.currentPage = index;
      queryRequestLogList();
    };

    //获取时间的年-月-日
    const dateFormat = dat => {
      if (dat) {
        let format = new Date(dat.toString());
        let resDate = format.getFullYear() + "-" + checkDate(format.getMonth() + 1) + "-" + checkDate(format.getDate());
        return resDate;
      }
      return null;
    };
    const checkDate = s => {
      return s < 10 ? "0" + s : s;
    };
    return {
      ...toRefs(data),
      proxy,
      queryRequestLogList,
      currentChange,
      resetForm,
      doDeleteHandler,
      checkDate,
      dateFormat
    };
  }
};